module.exports = __webpack_public_path__ + "img/button_qiehuan_2d02.1294a360.png";